import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconAddLarge(props: SvgIconProps) {
  return (
    <SVGIcon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9 3V15" stroke="currentColor" strokeWidth="2" />
      <path d="M3 9L15 9" stroke="currentColor" strokeWidth="2" />
    </SVGIcon>
  );
}
